import { useSelector } from 'react-redux';
import * as selector from "../../selectors/selectors";
import SettingsHeader from './settingsHeader.component';
import { appNote, buttonLabels, ToasterTexts } from '../shared/constants';
import { Autocomplete, FormHelperText, TextField, Tooltip } from '@mui/material';
import { LocalStorage, UtilityService } from '../../services/UtilityService';
import { mapToPhoneNumber, PhoneNumberModel } from '../../models/phone-number.model';
import { useEffect, useState } from 'react';
import { SettingsService } from '../../services/SettingsService';
import { ProfileModel } from '../../models/profile.model';
import { UserService } from '../../services/UserService';
import { ComplianceMsgModel, mapToComplianceMsgsettings } from '../../models/settings-model';
import CustomSwitch from '../shared/switch.component';
import ButtonComponent from '../shared/button/button.component';
import { setHeaderTitle } from '../../helpers/header.helper';
import AnimateLoader from "../shared/loaders/animate-loader.component";
import messagsLogsLoader from "../shared/loaders/message-logs-search-inprogress-loader.json";
import { useLocation } from 'react-router';
import { PhoneNumberService } from '../../services/PhonenumberService';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';
import { ComposerHelpCircleIcon } from '../../icon';
import _ from 'lodash';
import { UpdateOptInCollectedMessage } from '../../actions';
import { useDispatch } from 'react-redux';
import { updateOptInCollectedMessage } from '../../reducers/reducer';

const ComplianceMessage = () => {

    const { state } = useLocation();
    const dispatch = useDispatch()
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const PhoneNumbers: PhoneNumberModel[] = useSelector(selector.phoneNumbers);
    const IsDarkMode: boolean = useSelector(selector.isDarkMode);
    const OptInCollectedMessage: string = useSelector(selector.optInCollectedMessage)
    const Profile: ProfileModel = UserService.getCurrentUserFromLocalStorage();
    const OrgRef = UserService.hasSysAdminRole() ? state.orgreference : UserService.getCurrentUserOrgRef();
    const Settings = useSelector(selector.settings)

    const [compliancedata, setCompliancedata] = useState<ComplianceMsgModel>();
    const [data, setData] = useState<ComplianceMsgModel>();
    const [isEditingOptIn, setIsEditingOptIn] = useState(false);
    const [isEditingOptOut, setIsEditingOptOut] = useState(false);
    const [isEditingHelp, setIsEditingHelp] = useState(false);
    const [orgPhonumbers, setOrgPhonumbers] = useState<PhoneNumberModel[]>([])
    const [IsLoading, setIsLoading] = useState<boolean>(false)
    const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(true);
    const [optInCollectedMsg, setOptInCollectedMsg] = useState<string>(OptInCollectedMessage)
    const [isOptInCollectedMsgDisable, setIsOptInCollectedMsgDisable] = useState<boolean>(true)
    const [isOptInCollectLoading, setIsOptInCollectLoading] = useState<boolean>(false)

    const [errors, setErrors] = useState({
        OptInMessage: "",
        OptOutMessage: "",
        HelpMessage: "",
        OptInCollectedMsg: ""
    });
    const [characterLimit, setCharacterLimit] = useState({ OptInMessage: 160, OptOutMessage: 160, HelpMessage: 160, OptInCollectedMsg: 160 });

    const getMessageLength = (msg) => (msg ? msg.length : 0)
    const getMessageParts = (msg) => Math.ceil((getMessageLength(msg)) / 160)

    useEffect(() => {
        if (UserService.hasSysAdminRole()) {
            setHeaderTitle("Compliance Message");
            PhoneNumberService.getGridByOrganizations([state.organizationID]).then((res) => {
                if (res.status === 200) {
                    setOrgPhonumbers(res.data.map(mapToPhoneNumber));
                }
            }).catch((err) => {
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
            })
        } else {
            getComplianceMessageSetting(UtilityService.unmaskPhoneNumber(Profile.PhoneNumber), OrgRef)
            if (!OptInCollectedMessage) {
                UpdateOptInCollectedMessage(dispatch)
            }
        }
    }, [])

    useEffect(() => {
        setOptInCollectedMsg(OptInCollectedMessage)
    }, [OptInCollectedMessage])


    const getComplianceMessageSetting = (number, orgref) => {
        setIsLoading(true)
        SettingsService.getComplianceMessageSettings(number, orgref)
            .then((res => {
                setCompliancedata(mapToComplianceMsgsettings(res.data))
                setIsLoading(false)
                setData(mapToComplianceMsgsettings(res.data))
            })).catch()
    }

    const handleSwitch = (checked) => {
        const data = { ...compliancedata, IsOptInMessageEnabled: checked, OrgReference: OrgRef }
        // if (data && data.OptInMessage !== "" && data.OptOutMessage !== "" && data.HelpMessage !== "") setIsButtonDisabled(false)
        setIsButtonDisabled(false)
        setCompliancedata(data)
    }

    const handleSave = () => {
        if (!!compliancedata && compliancedata.OptInMessage !== "" && compliancedata.OptOutMessage !== "" && compliancedata.HelpMessage !== "") {
            const data = { ...compliancedata, OrgReference: OrgRef }
            UpdateComplianceMessageSetting(data);
        }
    };

    const UpdateComplianceMessageSetting = (data) => {
        setIsLoading(true);
        SettingsService.UpdateComplianceMessageSettings(data)
            .then((res => {
                setIsLoading(false);
                setIsButtonDisabled(true);
                setCompliancedata(mapToComplianceMsgsettings(res))
                setData(mapToComplianceMsgsettings(res))
                setToast(ToasterTexts.COMPLIANCEMESSAGE, ToasterType.SUCCESS)
            })).catch((err) =>
                setToast(ToasterTexts.SOMETHING_WENT_WRONG_ERROR, ToasterType.DANGER)
            )
    }

    const updateCharacterLimit = _.debounce((field, value, fieldName) => {
        let limit = UtilityService.getCharacterLimit(value, 2, 160)
        setCharacterLimit({ ...characterLimit, [field]: limit })
        const updatedErrors = {
            ...errors,
            [field]: value.trim() === "" ? `${fieldName} cannot be blank` : value.trim().length > limit ? `${fieldName} cannot be more than ${limit} characters` : "",
        };
        setErrors(updatedErrors);
        setIsButtonDisabled(Object.values(updatedErrors).some(error => error !== ""));
    }, 300);

    const handleTextFieldChange = (field: keyof ComplianceMsgModel, value: string, filedName: string) => {
        const updatedData = { ...compliancedata, [field]: value };
        setCompliancedata(updatedData);
        // const shouldDisable = [updatedData.OptInMessage, updatedData.OptOutMessage, updatedData.HelpMessage].some(msg => !msg.trim() || msg.length > 320);
        // setIsButtonDisabled(shouldDisable);
        // setErrors((prevErrors) => ({
        //     ...prevErrors,
        //     [field]: value.trim() === "" ? `${field} cannot be blank` : value.trim().length > 320 ? `${field} cannot be more that 320 Characters` : "",
        // }));

        updateCharacterLimit(field, value, filedName)

    };

    const handleCancel = () => {
        setCompliancedata(data);
        setIsButtonDisabled(true);
    };

    const handlephonenumbers = () => {
        const secondaryPhonenumbers = LocalStorage.get("current-user")?.secondaryPhoneNumbers.map(x => x.phoneNumberId)
        return PhoneNumbers.filter(x => secondaryPhonenumbers.includes(x.ID)) as any;
    }

    const handleSaveOptInCollectedMsg = () => {
        setIsOptInCollectLoading(true)
        SettingsService.updateOptInCollectedSetting(optInCollectedMsg).then((res) => {
            dispatch(updateOptInCollectedMessage(optInCollectedMsg))
            setIsOptInCollectLoading(false)
            setIsOptInCollectedMsgDisable(true)
        }).catch((err) => {
            setOptInCollectedMsg(OptInCollectedMessage)
            setIsOptInCollectLoading(false)
            setIsOptInCollectedMsgDisable(true)
        })
    }

    const handleChangeOptInCollectedMsg = (e) => {
        setOptInCollectedMsg(e.target.value);
        setIsOptInCollectedMsgDisable(false)
        updateCharacterLimit("OptInCollectedMsg", e.target.value, "Opt-In Collected message")
    }

    return (
        <div className=' h-p-100 o-y-scroll'>
            <div className={`m-auto   ${IsMobileDevice ? "p-1" : "pr-1"}`}>
                <div className={"d-flex flex-direction w-p-100"}>
                    <SettingsHeader IsMobileDevice={IsMobileDevice} Title={"Compliance Message"} />
                </div>
                <div className='schedule-report-border br-2 p-1'>
                    <div className='h5-regular pb-1'>* Select the phone number to generate an auto-response Compliance Message from.</div>
                    <Autocomplete
                        size="small"
                        className='bg-color-switchui-background'
                        classes={{ input: 'h5-regular', paper: 'bg-color-menu-bg box-shadow-none dialogue-shadow' }}
                        options={UserService.hasSysAdminRole() ? orgPhonumbers : UserService.hasManagerRole() ? handlephonenumbers() : PhoneNumbers}
                        getOptionLabel={(option) => UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber) + ` (${option?.Name})`}
                        value={!!compliancedata && compliancedata.PhoneNumber ? (UserService.hasSysAdminRole() ? orgPhonumbers : PhoneNumbers).find(x => x.PhoneNumber === compliancedata.PhoneNumber) : null}
                        onChange={(event, selectedOption) => {
                            setCompliancedata({ ...compliancedata, PhoneNumber: UtilityService.unmaskPhoneNumber(selectedOption.PhoneNumber) });
                            getComplianceMessageSetting(UtilityService.unmaskPhoneNumber(selectedOption.PhoneNumber), OrgRef)
                            setIsButtonDisabled(false)
                        }}
                        loading={IsLoading}
                        renderOption={(defaultprops, option: any) => (
                            <li {...defaultprops}>
                                <span className={" c-pointer color-menu-list-font-color w-p-92"}>
                                    <div className={`h5-regular ${!IsDarkMode ? "color-switchUIoption" : ""}`}> {UtilityService.maskPhoneNumberOnLength(option?.PhoneNumber)}</div>
                                    <div className='h5-regular color-nav-bar-font-color'>{option?.Name} </div>
                                </span>
                            </li>
                        )}
                        renderInput={(params) =>
                            <TextField {...params} name="phoneNumberId" required variant="outlined"
                                InputProps={{
                                    ...params.InputProps,
                                    endAdornment: (
                                        <div className='pl-2 mt-1 w-3'> {IsLoading && <AnimateLoader LoaderAnimation={messagsLogsLoader} />}
                                            {params.InputProps.endAdornment}
                                        </div>
                                    ),
                                }}
                            />}
                    />
                </div>
                <div className='schedule-report-border br-2 p-1 mt-1'>
                    <div className='pb-1 d-flex justify-between'>
                        <div className='d-flex align-center'>
                            <div className='h5-regular'> Opt-in Message *</div>
                           { !IsMobileDevice && <Tooltip title={appNote.COMPLIANCE_MESSAGE_TEXT} placement='right' >
                                <ComposerHelpCircleIcon className={` ml-1 c-pointer`} />
                            </Tooltip>}
                        </div>
                        <Tooltip title={compliancedata?.IsOptInMessageEnabled ? "Disable Opt-in Message" : "Enable Opt-in Message"} placement='bottom'>
                            <span>
                                <CustomSwitch
                                    checked={!!compliancedata && compliancedata.IsOptInMessageEnabled}
                                    onChange={(checked: boolean) => handleSwitch(checked)}
                                />
                            </span>
                        </Tooltip>
                    </div>
                    <div className='schedule-report-border br-2 bg-color-settings-background' >
                        <TextField
                            value={!!compliancedata ? compliancedata.OptInMessage : " "}
                            name="Opt-in Message"
                            onChange={(e) => handleTextFieldChange("OptInMessage", e.target.value, e.target.name)}
                            onFocus={() => setIsEditingOptIn(true)}
                            onBlur={() => { setIsEditingOptIn(false) }}
                            variant='standard'
                            size="small"
                            fullWidth
                            multiline
                            InputProps={{
                                classes: { input: `h5-regular p-1 ${isEditingOptIn || compliancedata?.OptInMessage != data?.OptInMessage ? "color-type-indicator-text" : "color-disabled-btn"} ${IsMobileDevice ? "h-6" : ""}` },
                                readOnly: !isEditingOptIn,
                                style: {
                                    cursor: isEditingOptIn ? 'text' : 'pointer',
                                },
                            }}
                        />
                    </div>
                    <div className='d-flex justify-between align-center h7-regular'>
                        <div className='d-flex'>
                            <p className="pr-1 color-con-hist-msg-date">{`Characters: ${getMessageLength(!!compliancedata && compliancedata.OptInMessage)}/${characterLimit.OptInMessage}`}</p>
                            <p className="pr-1 color-con-hist-msg-date">{`Parts: ${getMessageParts(!!compliancedata && compliancedata.OptInMessage)}/2`}</p>
                        </div>
                        {!!errors.OptInMessage && <FormHelperText className={'color-primary-danger '}>
                            {errors?.OptInMessage}
                        </FormHelperText>}
                    </div>
                </div>
                <div className='schedule-report-border br-2 p-1 mt-1'>
                    <div className='h5-regular'> Opt-out Message *</div>
                    <div className='schedule-report-border br-2  bg-color-settings-background' >
                        <TextField
                            name="Opt-out Message"
                            value={!!compliancedata ? compliancedata.OptOutMessage : " "}
                            onChange={(e) => handleTextFieldChange("OptOutMessage", e.target.value, e.target.name)}
                            onFocus={() => setIsEditingOptOut(true)}
                            onBlur={() => { setIsEditingOptOut(false) }}
                            variant='standard'
                            size="small"
                            fullWidth
                            multiline
                            InputProps={{
                                classes: { input: `h5-regular p-1 ${isEditingOptOut || compliancedata?.OptOutMessage != data?.OptOutMessage ? "color-type-indicator-text" : "color-disabled-btn"} ${IsMobileDevice ? "h-6" : ""}` },
                                readOnly: !isEditingOptOut,
                                style: {
                                    cursor: isEditingOptOut ? 'text' : 'pointer',
                                },
                            }}
                        />
                    </div>
                    <div className='d-flex justify-between align-center h7-regular'>
                        <div className='d-flex'>
                            <p className="pr-1 color-con-hist-msg-date">{`Characters: ${getMessageLength(!!compliancedata && compliancedata.OptOutMessage)}/${characterLimit.OptOutMessage}`}</p>
                            <p className="pr-1 color-con-hist-msg-date">{`Parts: ${getMessageParts(!!compliancedata && compliancedata.OptOutMessage)}/2`}</p>
                        </div>
                        {!!errors.OptOutMessage && <FormHelperText className={'color-primary-danger t-align-right'}>
                            {errors?.OptOutMessage}
                        </FormHelperText>}
                    </div>
                </div>
                <div className='schedule-report-border br-2 p-1 mt-1'>
                    <div className='h5-regular'> Help Message *</div>
                    <div className='schedule-report-border br-2 bg-color-settings-background' >
                        <TextField
                            name="Help Message"
                            value={!!compliancedata ? compliancedata.HelpMessage : " "}
                            onChange={(e) => handleTextFieldChange("HelpMessage", e.target.value, e.target.name)}
                            onFocus={() => setIsEditingHelp(true)}
                            onBlur={() => { setIsEditingHelp(false) }}
                            variant='standard'
                            size="small"
                            fullWidth
                            multiline
                            InputProps={{
                                classes: { input: `h5-regular p-1 ${isEditingHelp || compliancedata?.HelpMessage != data?.HelpMessage ? "color-type-indicator-text" : "color-disabled-btn"} ${IsMobileDevice ? "h-6" : ""}` },
                                readOnly: !isEditingHelp,
                                style: {
                                    cursor: isEditingHelp ? 'text' : 'pointer',
                                },
                            }}
                        />
                    </div>
                    <div className='d-flex justify-between align-center h7-regular'>
                        <div className='d-flex'>
                            <p className="pr-1 color-con-hist-msg-date">{`Characters: ${getMessageLength(!!compliancedata && compliancedata.HelpMessage)}/${characterLimit.HelpMessage}`}</p>
                            <p className="pr-1 color-con-hist-msg-date">{`Parts: ${getMessageParts(!!compliancedata && compliancedata.HelpMessage)}/2`}</p>
                        </div>
                        {!!errors.HelpMessage && <FormHelperText className={' color-primary-danger'}>
                            {errors?.HelpMessage}
                        </FormHelperText>}
                    </div>
                </div>
                <div className='d-flex pt-2 justify-flex-end'>
                    <ButtonComponent OnClick={handleCancel} ButtonLabel={buttonLabels.CANCEL} ClassName={`c-pointer mr-1 ${IsMobileDevice ? 'w-100' : 'w-p-10 justify-center  mb-2 br-1'}`} Variant={isButtonDisabled ? "disabled-btn-small" : "secondary-btn-small"} />
                    <ButtonComponent OnClick={handleSave} ButtonLabel={buttonLabels.SAVE} Loading={IsLoading} ClassName={`c-pointer ${IsMobileDevice ? 'w-100' : 'w-p-10 justify-center mb-2 br-1'}`} Variant={(Object.values(errors).some(msg => msg !== "") || isButtonDisabled) ? "disabled-btn-small" : "primary-btn-small"} />
                </div>
                {(!UserService.hasSysAdminRole() && Settings.find(x => x.Code === SettingsService.OptInCollect)?.Value == "true") && <>
                    <div className='schedule-report-border br-2 p-1 mt-1'>
                        <div className='h5-regular'> Opt-In Collect Message *</div>
                        <div className='schedule-report-border br-2 bg-color-settings-background ' >
                            <TextField
                                name="OptInCollectedMsg"
                                value={optInCollectedMsg}
                                onChange={(e) => { handleChangeOptInCollectedMsg(e) }}
                                variant='standard'
                                size="small"
                                fullWidth
                                multiline
                                InputProps={{
                                    classes: { input: `h5-regular p-1 ${!isOptInCollectedMsgDisable || compliancedata?.HelpMessage != data?.HelpMessage ? "color-type-indicator-text" : "color-disabled-btn"} ${IsMobileDevice ? "h-6" : ""}` },
                                }}
                            />
                        </div>
                        <div className='d-flex justify-between align-center h7-regular'>
                            <div className='d-flex'>
                                <p className="pr-1 color-con-hist-msg-date">{`Characters: ${getMessageLength(!!optInCollectedMsg && optInCollectedMsg)}/${characterLimit.OptInCollectedMsg}`}</p>
                                <p className="pr-1 color-con-hist-msg-date">{`Parts: ${getMessageParts(!!optInCollectedMsg && optInCollectedMsg)}/2`}</p>
                            </div>
                            {!!errors.OptInCollectedMsg && <FormHelperText className={'color-primary-danger'}>
                                {errors?.OptInCollectedMsg}
                            </FormHelperText>}
                        </div>
                    </div>
                    <div className='d-flex pt-2 justify-flex-end'>
                        <ButtonComponent OnClick={() => { setIsOptInCollectedMsgDisable(true); setOptInCollectedMsg(OptInCollectedMessage) }} ButtonLabel={buttonLabels.CANCEL} ClassName={`c-pointer ${IsMobileDevice ? 'w-100' : 'w-p-10 justify-center  mb-2 br-1'}`} Variant={isOptInCollectedMsgDisable ? "disabled-btn-small" : "secondary-btn-small"} />
                        <ButtonComponent OnClick={handleSaveOptInCollectedMsg} ButtonLabel={buttonLabels.SAVE} Loading={isOptInCollectLoading} ClassName={`c-pointer  mr-1 ${IsMobileDevice ? 'w-100' : 'w-p-10 justify-center mb-2 mr-2 br-1'}`} Variant={(isOptInCollectedMsgDisable || !!errors.OptInCollectedMsg) ? "disabled-btn-small" : "primary-btn-small"} />
                    </div>
                </>}
            </div>
        </div>
    )
}
export default ComplianceMessage
